const ls = window.localStorage;

export default {
    getItem(key) {
        // return JSON.parse(ls.getItem(key)) ? JSON.parse(ls.getItem(key)) : null;
        return ls.getItem(key) ? JSON.parse(ls.getItem(key)) : null;
    },

    setItem(key, val) {
        ls.setItem(key, JSON.stringify(val));
    },

    clear() {
        ls.clear();
    },

    keys(index) {
        return ls.key(index);
    },

    removeItem(key) {
        ls.removeItem(key);
    }
};